<template>
    <div class="acknowledgement-text">
        {{ _value }}<a href="#" v-if="requiresSnipping && !showFull" @click="loadFull" class="ml-1 more-link">More</a>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        snippetLength: {
            type: Number,
            default: 30
        }
    },
    data() {
        return {
            showFull: false
        }
    },
    computed: {
        _value() {
            if (!this.requiresSnipping || this.showFull)
                return this.value;
            else {
                return `${this.value.substring(0, this.snippetLength)}...`;
            }
        },
        requiresSnipping() {
            return this.value.length > this.snippetLength;
        }
    },
    methods: {
        loadFull() {
            if (!this.requiresSnipping) return;
            this.showFull = true;
        }
    }
}
</script>

<style scoped>
    .acknowledgement-text {
        font-style: italic;
    }
    .more-link {
        color: black;
        font-style: normal;
    }
</style>